// extracted by mini-css-extract-plugin
export default {"container":"AR-z","title":"BR-z","link":"CR-z"};